import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_229';

const stepsList = [
  /*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['604'] }
];

const tableStructure = [
  { id: 'pagador', title: 'Nombre pagador' },
  { id: 'origen', title: 'Origen información' },
  { id: 'valorItem', title: 'Valor' }
];



// Casilla 605	Nombre pagador
// Casilla 607	Valor
// Casilla 615	Retención






class Form1 {

  id: number;
  idSugerida: number;
  pagador: string;    //605
  valorItem: string;    //607
  total: string;    //607
  retencion: string;    //615    
  origen: string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-loterias-premios-rifas-apuestas-similares-modal.component',
  templateUrl: './ingresos-loterias-premios-rifas-apuestas-similares-modal.component.html',
  styleUrls: ['./ingresos-loterias-premios-rifas-apuestas-similares-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;

  model: DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,

    public dialogRef: MatDialogRef<IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    // this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {

  }


  protected inicializeForm() {

    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.idSugerida = 0;


    this.modelForm.pagador = '';
    this.modelForm.origen = '';
    this.modelForm.valorItem = '0';
    this.modelForm.retencion = '0';

    this.reloadSelArticulos();
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_605 == undefined) {


      this.model.doc.cuerpo.cc_id_605 = []; //Pagador
      this.model.doc.cuerpo.cc_id_606 = []; //OrigenDeLaInformación
      this.model.doc.cuerpo.cc_id_607 = []; //valorItem
      this.model.doc.cuerpo.cs_id_608 = '0'; //Total
      this.model.doc.cuerpo.cc_id_615 = []; //retención

    }
  }

  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649


  }

  protected initializeAnios() {



  }

  public operacionCs608() {
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valorItem, suma);
    }
    if (suma)
      this.model.doc.cuerpo.cs_id_608 = suma;
    else
      this.model.doc.cuerpo.cs_id_608 = '0';
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158, true);
  }


  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_605.length; i++) {
      this.modelForm.id = i;

      this.modelForm.pagador = this.model.doc.cuerpo.cc_id_605[i].v;
      this.modelForm.origen = this.model.doc.cuerpo.cc_id_606[i].v;
      this.modelForm.valorItem = this.dutilidades.obtenerFormatoMoneda(this.model.doc.cuerpo.cc_id_607[i].v);
      this.modelForm.retencion = this.model.doc.cuerpo.cc_id_615[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.operacionCs608();
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida() {

    let indexModel = this.model.doc.cuerpo.cc_id_605.length;

    if (indexModel == 0) {
      const fieldsRecovery = ['VAR_2370','VAR_2586','VAR_2370','VAR_2370','VAR_2370','VAR_3674','VAR_2077'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      
      const grupos=[
        ['VAR_2370','VAR_2586','VAR_2370','VAR_2370','VAR_2370','VAR_3674'],
        ['VAR_2077']
      ];

      if (resData) {
        for (let i = 0; i < resData.length; i++) {
          for (let j = 0; j < resData[i].item.value.length; j++) {


            this.modelForm.id = indexModel;

            this.modelForm.pagador = resData[i].item.numNitInformante[j] + "/" + resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.origen = '0';//this.data.sugerida[i].origen;
            
            let itemGrupoFormPorEditar:Form1 = null;

            //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
            let idGrupo:number = -1;
            for(let k=0;k<grupos.length;k++){
              if(grupos[k].includes(resData[i].key)){
                idGrupo=k;
                break;
              }
            }

            //1. El nit ya existe? NO ->1:Agregar
            if(this.dataSourceBody.find((el)=>{
              return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
            })==undefined){
              itemGrupoFormPorEditar = null;
            }else{

              //2. Trae array de solo los del NIT
              let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                  return el;
                }
              });

              //3. Recorrer array de solo los del NIT
              for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                //En el registro existe una variable del GRUPO? 
                //  - NO: Debe Editar el registro y deja de buscar
                //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                if(!dataGrupo){
                  itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                  break;
                }
              }

            }
            
            //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
            if(itemGrupoFormPorEditar){
              this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                if(itemModelForm.id == itemGrupoFormPorEditar.id){
                  itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                  itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                }
                return itemModelForm;
              });
            }else{
              this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
              this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
              this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
              this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
              this.redondearFormData();
              this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
              this.dataSourceBody.push(this.modelForm);
              this.inicializeForm();
              indexModel++;
            }


          }
        }
      }

    }

    this.operacionCs608();
  }

  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
    switch(idGrupo){//Depende de la variable array grupos
      case 0:
        itemModelForm.valorItem=String(valor);
      break;
      case 1:
        itemModelForm.retencion=String(valor);
      break;
      default:
      break;
    }
    return itemModelForm;
  }

  public editModeloDesdeForm() {


    this.model.doc.cuerpo.cc_id_605[this.modelForm.id].v = this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_606[this.modelForm.id].v = this.modelForm.origen;
    this.model.doc.cuerpo.cc_id_607[this.modelForm.id].v = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valorItem);
    this.model.doc.cuerpo.cc_id_615[this.modelForm.id].v = this.modelForm.retencion;


  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;


    this.model.doc.cuerpo.cc_id_605.push({ it: i, v: this.modelForm.pagador });
    this.model.doc.cuerpo.cc_id_606.push({ it: i, v: this.modelForm.origen });
    this.model.doc.cuerpo.cc_id_607.push({ it: i, v: this.dutilidades.deshacerFormatoMoneda(this.modelForm.valorItem) });
    this.model.doc.cuerpo.cc_id_615.push({ it: i, v: this.modelForm.retencion });

  }

  public deleteOnModel(index: number) {



    this.model.doc.cuerpo.cc_id_605.splice(index, 1);
    this.model.doc.cuerpo.cc_id_606.splice(index, 1);
    this.model.doc.cuerpo.cc_id_607.splice(index, 1);
    this.model.doc.cuerpo.cc_id_615.splice(index, 1);

    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_605.length; i++) {

      this.model.doc.cuerpo.cc_id_605[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_606[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_607[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_615[i].it = i + 1;

    }
  }

  public validateFormCompleted(): boolean {


    return (

      this.modelForm.pagador == undefined || this.modelForm.pagador == null ||
      this.modelForm.origen == undefined || this.modelForm.origen == null ||
      this.modelForm.valorItem == undefined || this.modelForm.valorItem == null ||
      this.modelForm.retencion == undefined || this.modelForm.retencion == null
    );
  }

  public redondearFormData() {
    // console.log('this.modelForm antes de redondear:' + JSON.stringify(this.modelForm));



    this.modelForm.valorItem = this.dutilidades.redondearValorMoneda(this.modelForm.valorItem, true);
    this.modelForm.retencion = this.dutilidades.redondearValorMoneda(this.modelForm.retencion, true);

    // console.log('this.modelForm después de redondear:' + JSON.stringify(this.modelForm));
  }

  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();

    //casillas ocultas vvvv



    this.reloadSelArticulos(conservarArt);
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla == this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        // const existeValor = this.model.doc.cuerpo.cc_id_605.some(item => item.v === this.modelForm.pagador);


        // if (this.modelForm.origen == "2" || this.modelForm.origen == "1" || (existeValor && this.modelForm.origen == "0")) { //editando contribuyente o editando sugerida
        //   this.modelForm.origen = this.modelForm.origen == "0" && this.modelForm.origen == "0" ? "1" : this.modelForm.origen;
        //   this.editModeloDesdeForm();
        // } else if (this.modelForm.origen == "0") { //editando sugerida
        //   this.modelForm.origen = "1";
        //   this.modelForm.id = this.model.doc.cuerpo.cc_id_605.length;
        //   this.addToModeloDesdeForm();
        // }
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

        // this.modelForm.nombreConcepto = this.lstConceptos[Number(this.modelForm.concepto) - 1].nombre;//envía nombre de concepto a la tabla de dividendos
        // this.editModeloDesdeForm();
      } else if (this.operacionTabla == this.OPERACION_AGREGAR) { //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_605.length;
        this.modelForm.origen = "2";
        // this.modelForm.informante = "Contribuyente";
        // this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion) - 1].nombre;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs608();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCs608();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }


  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  /*   public validateRbQuestions(val: string) {
      this.modelForm.aplicoArt73 = val;
      this.calcularValoresForm();
    } */

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;

    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number) {

  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /*  public validateStepHabilitado(indexS:number):boolean{
     let habilitado = true;
     return habilitado;
   } */

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /* public validateBtnRightActive(){

  } */

  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave() {
    if (this.indexStepper == this.stepsList.length - 1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO) { this.showSave = true };
  }

  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCs608();
    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar() {
     //Limpiar modelo y agregar el contenido de la tabla
     this.model.doc.cuerpo.cc_id_605 = undefined;
     this.inicializeModelo();
     for(let i=0; i<this.dataSourceBody.length; i++){
       this.modelForm = this.dataSourceBody[i];
       this.addToModeloDesdeForm();
     }

     this.operacionCs608();



     this.saveModel.emit(true); 
     //if(this.indexStepper==this.stepsList.length-1){
     this.closeModal();
     //} 
     console.log('Model loterías: ',this.model);
   }
   public borrarTabla(){
     this.dataSourceBody = [];
   }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-loterias-premios-rifas-apuestas-similares-modal/ingresos-loterias-premios-rifas-apuestas-similares-modal.component.ts